// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"26":"ce5acba4","949":"18a9b648"}[chunkId] + ".css";
};